<template>
	<div class="flex-row flex-just-end">
		<div
			v-for="item in sortList"
			:key="item.key"
			class="fz-14 flex-row flex-align-center color-gy-8 ml-20 cursor-pointer font-h4-regular"
			:class="{ 'yx-color-primary font-h4-medium': activeId == item.key }"
			@click="handleOrderBy(item.key)"
		>
			{{ item.name }}
			<div v-if="item.key != 'default'">
				<div style="height: 5px">
					<i class="el-icon-caret-top fz-12 color-gy-6" :class="{ 'yx-color-primary': activeId == item.key && sort == 'asc' }"></i>
				</div>
				<div>
					<i class="el-icon-caret-bottom fz-12 color-gy-6" :class="{ 'yx-color-primary': activeId == item.key && sort == 'desc' }"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			activeId: 'default',
			sort: '',
		};
	},
	computed: {
		sortList() {
			if (this.$isSp()) {
				return [
					// {
					// 	name: '综合排序',
					// 	key: 'default',
					// },
					{
						name: '粉丝数',
						key: 'fans_num',
					},
					{
						name: '30日带货商品数',
						key: 'promotion_pro_num',
					},
					{
						name: '30日销售额',
						key: 'fee_30',
					},
					{
						name: '30日场均销售额',
						key: 'live_sale',
					},
				];
			}
		},
	},
	watch: {
		platformId() {
			this.activeId = 'default';
			this.sort = '';
		},
	},
	methods: {
		handleOrderBy(key) {
			if (this.activeId == key) {
				if (this.sort == 'desc') {
					this.sort = '';
					this.activeId = 'default';
				}
				this.sort == 'asc' && (this.sort = 'desc');
			} else {
				this.activeId = key;
				this.sort = this.key == 'default' ? '' : 'asc';
			}
			if (this.activeId == 'default') {
				this.$emit('sortChange', '');
			} else {
				this.$emit('sortChange', `${this.activeId}_${this.sort}`);
			}
		},
	},
};
</script>

<style lang="less" scoped></style>
